import React, { useState, useRef, useEffect } from 'react';
import { Check } from 'lucide-react';

export default function AutocompleteSelect({ options, value, onChange, placeholder, className = '', dataTestId }) {
  const [isOpen, setIsOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [filteredOptions, setFilteredOptions] = useState(options);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const filtered = options.filter(option =>
      option.toLowerCase().includes(search.toLowerCase())
    );
    setFilteredOptions(filtered);
  }, [search, options]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
        setSearch('');
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (option) => {
    onChange(option);
    setIsOpen(false);
    setSearch('');
  };

  return (
    <div ref={wrapperRef} className={`relative ${className}`}>
      <input
        type="text"
        value={isOpen ? search : value || ''}
        onChange={(e) => {
          setSearch(e.target.value);
          if (!isOpen) setIsOpen(true);
        }}
        onFocus={() => setIsOpen(true)}
        placeholder={placeholder}
        data-testid={dataTestId}
        className="w-full h-12 px-4 rounded-lg border border-slate-200 bg-white focus:ring-2 focus:ring-[#4A90E2]/20 focus:border-[#4A90E2] font-public transition-all"
      />
      
      {isOpen && filteredOptions.length > 0 && (
        <div className="absolute z-50 w-full mt-2 bg-white rounded-lg border border-slate-200 shadow-lg max-h-60 overflow-y-auto">
          {filteredOptions.map((option, index) => (
            <div
              key={index}
              onClick={() => handleSelect(option)}
              className={`px-4 py-3 cursor-pointer hover:bg-slate-50 transition-colors flex items-center justify-between ${
                value === option ? 'bg-[#4A90E2]/5' : ''
              }`}
            >
              <span className="font-public text-sm text-[#262626]">{option}</span>
              {value === option && <Check className="h-4 w-4 text-[#2DD4BF]" />}
            </div>
          ))}
        </div>
      )}
      
      {isOpen && filteredOptions.length === 0 && search && (
        <div className="absolute z-50 w-full mt-2 bg-white rounded-lg border border-slate-200 shadow-lg">
          <div className="px-4 py-3 text-sm text-[#4B5563] font-public">
            No results found
          </div>
        </div>
      )}
    </div>
  );
}